// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survivor-picks-bar-small-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid #757575;
  cursor: pointer;
}
.survivor-picks-bar-small-container.placeholder {
  border-color: transparent;
  opacity: 0;
  pointer-events: none;
}
@media (max-width: 900px) {
  .survivor-picks-bar-small-container {
    width: 62px;
    height: 72px;
    min-width: 62px;
    min-height: 72px;
    gap: 8px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-small-container {
    width: 108.5px;
    height: 124.5px;
    min-width: 108.5px;
    min-height: 124.5px;
    gap: 14px;
  }
}
.survivor-picks-bar-small-game {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@media (max-width: 900px) {
  .survivor-picks-bar-small-game {
    padding: 4px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-small-game {
    padding: 8px;
  }
}
.survivor-picks-bar-small-top-text {
  font-weight: 700 !important;
  color: #757575;
  white-space: nowrap;
}
@media (max-width: 900px) {
  .survivor-picks-bar-small-top-text {
    font-size: 10px !important;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-small-top-text {
    font-size: 16px !important;
  }
}
.survivor-picks-bar-small-logo-container {
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #757575;
}
@media (max-width: 900px) {
  .survivor-picks-bar-small-logo-container {
    width: 26px;
    height: 26px;
    min-width: 26px;
    min-height: 26px;
    margin: 4px 0;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-small-logo-container {
    width: 45.5px;
    height: 45.5px;
    min-width: 45.5px;
    min-height: 45.5px;
    margin: 8px 0;
  }
}
.survivor-picks-bar-small-logo {
  position: relative;
  object-fit: contain;
}
@media (max-width: 900px) {
  .survivor-picks-bar-small-logo {
    width: 24px;
    height: 24px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-small-logo {
    width: 40px;
    height: 40px;
  }
}
.survivor-picks-bar-small-bottom-text-container {
  display: flex;
  align-self: stretch;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
@media (max-width: 900px) {
  .survivor-picks-bar-small-bottom-text-container {
    padding: 0 6px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-small-bottom-text-container {
    padding: 0 10.5px;
  }
}
.survivor-picks-bar-small-bottom-text {
  font-weight: 700 !important;
  color: #757575;
  white-space: nowrap;
}
@media (max-width: 900px) {
  .survivor-picks-bar-small-bottom-text {
    font-size: 10px !important;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-small-bottom-text {
    font-size: 16px !important;
  }
}

.survivor-picks-bar-small-empty-logo {
  background-color: #E5E5E5;
}
@media (max-width: 900px) {
  .survivor-picks-bar-small-empty-logo {
    width: 26px;
    height: 26px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-small-empty-logo {
    width: 45.5px;
    height: 45.5px;
  }
}

.survivor-picks-bar-small-eliminated-icon {
  margin: 0 auto;
  color: #CC293C;
}
@media (max-width: 900px) {
  .survivor-picks-bar-small-eliminated-icon {
    font-size: 24px !important;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-small-eliminated-icon {
    font-size: 40px !important;
  }
}

.survivor-picks-bar-large-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid #002129;
}
@media (max-width: 900px) {
  .survivor-picks-bar-large-container {
    width: 70px;
    height: 82px;
    min-width: 70px;
    min-height: 82px;
    gap: 8px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-large-container {
    width: 122.5px;
    height: 142px;
    min-width: 122.5px;
    min-height: 142.5px;
    gap: 14px;
  }
}
.survivor-picks-bar-large-game {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@media (max-width: 900px) {
  .survivor-picks-bar-large-game {
    padding: 4px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-large-game {
    padding: 8px;
  }
}
.survivor-picks-bar-large-top-text {
  font-weight: 700 !important;
  color: #002129;
  white-space: nowrap;
}
@media (max-width: 900px) {
  .survivor-picks-bar-large-top-text {
    font-size: 12px !important;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-large-top-text {
    font-size: 21px !important;
  }
}
.survivor-picks-bar-large-logo-container {
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #002129;
}
@media (max-width: 900px) {
  .survivor-picks-bar-large-logo-container {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    margin: 4px 0;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-large-logo-container {
    width: 56px;
    height: 56px;
    min-width: 56px;
    min-height: 56px;
    margin: 8px 0;
  }
}
.survivor-picks-bar-large-logo {
  position: relative;
  object-fit: contain;
}
@media (max-width: 900px) {
  .survivor-picks-bar-large-logo {
    width: 28px;
    height: 28px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-large-logo {
    width: 48px;
    height: 48px;
  }
}
.survivor-picks-bar-large-bottom-text-container {
  display: flex;
  align-self: stretch;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
@media (max-width: 900px) {
  .survivor-picks-bar-large-bottom-text-container {
    padding: 0 6px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-large-bottom-text-container {
    padding: 0 10.5px;
  }
}
.survivor-picks-bar-large-bottom-text {
  font-weight: 700 !important;
  color: #002129;
  white-space: nowrap;
}
@media (max-width: 900px) {
  .survivor-picks-bar-large-bottom-text {
    font-size: 12px !important;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-large-bottom-text {
    font-size: 21px !important;
  }
}

.survivor-picks-bar-large-empty-logo {
  background-color: #E5E5E5;
}
@media (max-width: 900px) {
  .survivor-picks-bar-large-empty-logo {
    width: 32px;
    height: 32px;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-large-empty-logo {
    width: 56px;
    height: 56px;
  }
}

.survivor-picks-bar-large-eliminated-icon {
  margin: 0 auto;
  color: #CC293C;
}
@media (max-width: 900px) {
  .survivor-picks-bar-large-eliminated-icon {
    font-size: 32px !important;
  }
}
@media (min-width: 901px) {
  .survivor-picks-bar-large-eliminated-icon {
    font-size: 56px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SurvivorGames/MyPicks/SurvivorPicksBar.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;AAAR;AAEQ;EACI,yBAAA;EACA,UAAA;EACA,oBAAA;AAAZ;AAGQ;EAdJ;IAeQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,QAAA;EAAV;AACF;AAEQ;EAtBJ;IAuBQ,cAAA;IACA,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,SAAA;EACV;AACF;AAEI;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAEQ;EAPJ;IAQQ,YAAA;EACV;AACF;AACQ;EAXJ;IAYQ,YAAA;EAEV;AACF;AACI;EACI,2BAAA;EACA,cAAA;EACA,mBAAA;AACR;AACQ;EALJ;IAMQ,0BAAA;EAEV;AACF;AAAQ;EATJ;IAUQ,0BAAA;EAGV;AACF;AAAI;EACI,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAER;AAAQ;EAVJ;IAWQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,aAAA;EAGV;AACF;AADQ;EAlBJ;IAmBQ,aAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;IACA,aAAA;EAIV;AACF;AADI;EACI,kBAAA;EACA,mBAAA;AAGR;AADQ;EAJJ;IAKQ,WAAA;IACA,YAAA;EAIV;AACF;AAFQ;EATJ;IAUQ,WAAA;IACA,YAAA;EAKV;AACF;AAFI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAIR;AAFQ;EAPJ;IAQQ,cAAA;EAKV;AACF;AAHQ;EAXJ;IAYQ,iBAAA;EAMV;AACF;AAHI;EACI,2BAAA;EACA,cAAA;EACA,mBAAA;AAKR;AAHQ;EALJ;IAMQ,0BAAA;EAMV;AACF;AAJQ;EATJ;IAUQ,0BAAA;EAOV;AACF;;AAFA;EACI,yBAAA;AAKJ;AAHI;EAHJ;IAIQ,WAAA;IACA,YAAA;EAMN;AACF;AAJI;EARJ;IASQ,aAAA;IACA,cAAA;EAON;AACF;;AAJA;EACI,cAAA;EACA,cAAA;AAOJ;AALI;EAJJ;IAKQ,0BAAA;EAQN;AACF;AANI;EARJ;IASQ,0BAAA;EASN;AACF;;AAJI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;AAOR;AALQ;EAPJ;IAQQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,QAAA;EAQV;AACF;AANQ;EAfJ;IAgBQ,cAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,SAAA;EASV;AACF;AANI;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAQR;AANQ;EAPJ;IAQQ,YAAA;EASV;AACF;AAPQ;EAXJ;IAYQ,YAAA;EAUV;AACF;AAPI;EACI,2BAAA;EACA,cAAA;EACA,mBAAA;AASR;AAPQ;EALJ;IAMQ,0BAAA;EAUV;AACF;AARQ;EATJ;IAUQ,0BAAA;EAWV;AACF;AARI;EACI,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAUR;AARQ;EATJ;IAUQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,aAAA;EAWV;AACF;AATQ;EAjBJ;IAkBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,aAAA;EAYV;AACF;AATI;EACI,kBAAA;EACA,mBAAA;AAWR;AATQ;EAJJ;IAKQ,WAAA;IACA,YAAA;EAYV;AACF;AAVQ;EATJ;IAUQ,WAAA;IACA,YAAA;EAaV;AACF;AAVI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAYR;AAVQ;EAPJ;IAQQ,cAAA;EAaV;AACF;AAXQ;EAXJ;IAYQ,iBAAA;EAcV;AACF;AAXI;EACI,2BAAA;EACA,cAAA;EACA,mBAAA;AAaR;AAXQ;EALJ;IAMQ,0BAAA;EAcV;AACF;AAZQ;EATJ;IAUQ,0BAAA;EAeV;AACF;;AAVA;EACI,yBAAA;AAaJ;AAXI;EAHJ;IAIQ,WAAA;IACA,YAAA;EAcN;AACF;AAZI;EARJ;IASQ,WAAA;IACA,YAAA;EAeN;AACF;;AAZA;EACI,cAAA;EACA,cAAA;AAeJ;AAbI;EAJJ;IAKQ,0BAAA;EAgBN;AACF;AAdI;EARJ;IASQ,0BAAA;EAiBN;AACF","sourcesContent":[".survivor-picks-bar-small {\n    &-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: flex-start;\n        border: 1px solid #757575;\n        cursor: pointer;\n\n        &.placeholder {\n            border-color: transparent;\n            opacity: 0;\n            pointer-events: none;\n        }\n\n        @media (max-width: 900px) { // mobile\n            width: 62px;\n            height: 72px;\n            min-width: 62px;\n            min-height: 72px;\n            gap: 8px;\n        }\n\n        @media (min-width: 901px) { // desktop\n            width: 108.5px;\n            height: 124.5px;\n            min-width: 108.5px;\n            min-height: 124.5px;\n            gap: 14px;\n        }\n    }\n\n    &-game {\n        display: flex;\n        width: 100%;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        @media (max-width: 900px) {\n            padding: 4px;\n        }\n\n        @media (min-width: 901px) {\n            padding: 8px;\n        }\n    }\n\n    &-top-text {\n        font-weight: 700 !important;\n        color: #757575;\n        white-space: nowrap;\n\n        @media (max-width: 900px) {\n            font-size: 10px !important;\n        }\n\n        @media (min-width: 901px) {\n            font-size: 16px !important;\n        }\n    }\n\n    &-logo-container {\n        box-sizing: border-box;\n        overflow: hidden;\n        flex-shrink: 0;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid #757575;\n\n        @media (max-width: 900px) {\n            width: 26px;\n            height: 26px;\n            min-width: 26px;\n            min-height: 26px;\n            margin: 4px 0;\n        }\n\n        @media (min-width: 901px) {\n            width: 45.5px;\n            height: 45.5px;\n            min-width: 45.5px;\n            min-height: 45.5px;\n            margin: 8px 0;\n        }\n    }\n\n    &-logo {\n        position: relative;\n        object-fit: contain;\n\n        @media (max-width: 900px) {\n            width: 24px;\n            height: 24px;\n        }\n\n        @media (min-width: 901px) {\n            width: 40px;\n            height: 40px;\n        }\n    }\n\n    &-bottom-text-container {\n        display: flex;\n        align-self: stretch;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n\n        @media (max-width: 900px) {\n            padding: 0 6px;\n        }\n\n        @media (min-width: 901px) {\n            padding: 0 10.5px;\n        }\n    }\n\n    &-bottom-text {\n        font-weight: 700 !important;\n        color: #757575;\n        white-space: nowrap;\n\n        @media (max-width: 900px) {\n            font-size: 10px !important;\n        }\n\n        @media (min-width: 901px) {\n            font-size: 16px !important;\n        }\n    }\n}\n\n// Additional styles for empty and eliminated states\n.survivor-picks-bar-small-empty-logo {\n    background-color: #E5E5E5;\n\n    @media (max-width: 900px) {\n        width: 26px;\n        height: 26px;\n    }\n\n    @media (min-width: 901px) {\n        width: 45.5px;\n        height: 45.5px;\n    }\n}\n\n.survivor-picks-bar-small-eliminated-icon {\n    margin: 0 auto;\n    color: #CC293C;\n\n    @media (max-width: 900px) {\n        font-size: 24px !important;\n    }\n\n    @media (min-width: 901px) {\n        font-size: 40px !important;\n    }\n}\n\n\n.survivor-picks-bar-large {\n    &-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: flex-start;\n        border: 1px solid #002129;\n\n        @media (max-width: 900px) {\n            width: 70px;\n            height: 82px;\n            min-width: 70px;\n            min-height: 82px;\n            gap: 8px;\n        }\n\n        @media (min-width: 901px) {\n            width: 122.5px;\n            height: 142px;\n            min-width: 122.5px;\n            min-height: 142.5px;\n            gap: 14px;\n        }\n    }\n\n    &-game {\n        display: flex;\n        width: 100%;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        @media (max-width: 900px) {\n            padding: 4px;\n        }\n\n        @media (min-width: 901px) {\n            padding: 8px;\n        }\n    }\n\n    &-top-text {\n        font-weight: 700 !important;\n        color: #002129;\n        white-space: nowrap;\n\n        @media (max-width: 900px) {\n            font-size: 12px !important;\n        }\n\n        @media (min-width: 901px) {\n            font-size: 21px !important;\n        }\n    }\n\n    &-logo-container {\n        box-sizing: border-box;\n        overflow: hidden;\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid #002129;\n\n        @media (max-width: 900px) {\n            width: 32px;\n            height: 32px;\n            min-width: 32px;\n            min-height: 32px;\n            margin: 4px 0;\n        }\n\n        @media (min-width: 901px) {\n            width: 56px;\n            height: 56px;\n            min-width: 56px;\n            min-height: 56px;\n            margin: 8px 0;\n        }\n    }\n\n    &-logo {\n        position: relative;\n        object-fit: contain;\n\n        @media (max-width: 900px) {\n            width: 28px;\n            height: 28px;\n        }\n\n        @media (min-width: 901px) {\n            width: 48px;\n            height: 48px;\n        }\n    }\n\n    &-bottom-text-container {\n        display: flex;\n        align-self: stretch;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n\n        @media (max-width: 900px) {\n            padding: 0 6px;\n        }\n\n        @media (min-width: 901px) {\n            padding: 0 10.5px;\n        }\n    }\n\n    &-bottom-text {\n        font-weight: 700 !important;\n        color: #002129;\n        white-space: nowrap;\n\n        @media (max-width: 900px) {\n            font-size: 12px !important;\n        }\n\n        @media (min-width: 901px) {\n            font-size: 21px !important;\n        }\n    }\n}\n\n// Additional styles for empty and eliminated states\n.survivor-picks-bar-large-empty-logo {\n    background-color: #E5E5E5;\n\n    @media (max-width: 900px) {\n        width: 32px;\n        height: 32px;\n    }\n\n    @media (min-width: 901px) {\n        width: 56px;\n        height: 56px;\n    }\n}\n\n.survivor-picks-bar-large-eliminated-icon {\n    margin: 0 auto;\n    color: #CC293C;\n\n    @media (max-width: 900px) {\n        font-size: 32px !important;\n    }\n\n    @media (min-width: 901px) {\n        font-size: 56px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
